import { FunctionComponent } from "react";
import GalleryTemplate from "./GalleryTemplate";

export interface IGallerySingle {
  configsFromLayout: any;
}
const GallerySingle: FunctionComponent<IGallerySingle> = ({
  configsFromLayout,
}) => {
  const duration = configsFromLayout.configs.duration.value * 1000;
  const getConfig = (key: string) => configsFromLayout?.configs?.[key]?.value;

  function SingleMediaCases(post: any, index: number) {
    if (typeof post === "string") {
      return (
        <img
          src={post}
          alt={`Slide ${index}`}
          className={
            getConfig("stretch_image")
              ? "w-full h-full object-cover"
              : "max-w-[100%] max-h-[100%] object-contain"
          }
        />
      );
    }
  }
  return (
    <GalleryTemplate
      configs={{
        autoplay: { delay: duration },
        slidesPerView: 1,
        speed: 2500,
        className: "h-full w-full",
        transition: getConfig("transition"),
      }}
      children={configsFromLayout?.configs?.gallery?.value.map(
        (post: any, index: number) => (
          <div key={index} className="landscape:flex justify-center w-full h-full">
            <div className="landscape:w-[100%] landscape:h-full landscape:flex justify-center portrait:w-full portrait:h-[95%] p-[2.4vh]">
              {SingleMediaCases(post, index)}
            </div>
          </div>
        )
      )}
      configsFromLayout={configsFromLayout}
    />
  );
};

export default GallerySingle;
